import gql from 'graphql-tag';

import {useProjectRunStoreAcceleratorReadEnabledQuery} from '../../generated/graphql';

export const PROJECT_RSA_READ_ENABLED_QUERY = gql`
  query ProjectRunStoreAcceleratorReadEnabled(
    $entityName: String!
    $projectName: String!
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      runStoreAcceleratorReadEnabled
    }
  }
`;

/**
 * Whether the current project's run reads are served from the Run Store
 * Accelerator (ClickHouse) for the current viewer.
 *
 * This is the read router's own decision: the accelerator is wired, the
 * project's backfill has finished, and the ch_runs_read_from_accelerator ramp
 * is on for this user/project. Features that assume accelerator-backed reads
 * (e.g. next-gen workspaces) can gate on this single value instead of combining
 * the ramp and backfill state themselves.
 *
 * Returns false while the query is loading, on error, or off a project route.
 */
export const useProjectRsaReadEnabled = (
  entityName: string | undefined,
  projectName: string | undefined
): boolean => {
  const skip = entityName == null || projectName == null;
  const {data} = useProjectRunStoreAcceleratorReadEnabledQuery({
    variables: {
      entityName: entityName ?? '',
      projectName: projectName ?? '',
    },
    skip,
  });
  return data?.project?.runStoreAcceleratorReadEnabled === true;
};
